export default "__VITE_ASSET__BpbP_mBg__"